import styled from 'styled-components';

import { rem } from '@vimeo/bokeh';
import { Modal } from '@vimeo/iris/components';

interface Props {
  isBokeh?: boolean;
  hasFreeFeaturedBanner?: boolean;
}

export const UpsellModal = styled(Modal)<Props>`
  ${(props: Props) => props.isBokeh && `font-family: 'ABCRepro-Regular', sans-serif !important;`}
  ${(props: Props) => props.hasFreeFeaturedBanner && `margin-top: 40px;`}
  background: var(--vimeo-colors-fill-surface);
  min-width: 62.5rem;
  width: 100%;
  height: auto;
  max-width: ${rem(1180)};
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 1.25rem;
  max-height: 95vh !important;
  padding: 0;
  overflow: scroll;

  > div {
    max-height: 95vh !important;
    overflow: scroll;
  }
`;

export const ModalWrapper = styled.div`
  padding: ${rem(32)} ${rem(32)} ${rem(16)};
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${rem(24)} ${rem(24)};
  align-items: center;
  align-self: stretch;
`;

export const HeaderWrapper = styled.div`
  color: var(--vimeo-colors-text-primary);
  font-size: ${rem(28)};
  font-weight: 700;
  line-height: 118%;
  letter-spacing: ${rem(-1)};
  text-align: center;
  margin-bottom: ${rem(4)};
`;

export const SubHeader = styled.p`
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: center;
  color: var(--vimeo-colors-text-primary);
`;

export const PlansContainer = styled.div`
  padding: 1rem 0 ${rem(20)} 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 0.75rem;
  z-index: 1;
  position: relative;
`;

export const FooterContainer = styled.div`
  margin: 0 -1rem;
  padding: 0 1.5rem 0 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
`;
